import React from 'react';
import PropTypes from 'prop-types';
import Button from '../../Button';
import styles from './ShareModal.module.scss';
import HuntsIcon from '../../../assets/svg/HuntsIcon';
import { COLORS } from '../../../lib/constants';

function ShareModal(props) {
  const Icon = props.icon;

  return (
    <div className={styles.container}>
      <div className={styles.textContainer}>
        <div className={styles.grantableIcon}>
          <Icon width={20} height={20} color={COLORS.ghOrange} />
        </div>
        <h1 className={styles.title}>{props.title}</h1>
        <h2 className={styles.subtitle}>{props.subtitle}</h2>
        <input
          type="text"
          readOnly
          value={props.shareLink} />
      </div>
      <div className={styles.actionButtons}>
        {props.actionItems.map((actionItem,index) => {
          return (
            <Button 
              key={index}
              theme={actionItem.theme || Button.THEME.orange}
              size={Button.SIZE.medium}
              className={actionItem.className || styles.actionItem}
              onClick={actionItem.onClick}
            >
              {actionItem.title}
            </Button>
          );
        })}
      </div>
    </div>
  );
}

ShareModal.defaultProps = {
  icon: HuntsIcon
};

ShareModal.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  shareLink: PropTypes.string,
  actionItems: PropTypes.array,
  icon: PropTypes.func
};

export default ShareModal;
